function isInViewport(el) {
  const rect = el?.getBoundingClientRect();
  return (
    rect.top >= 0 &&
    rect.left >= 0 &&
    rect.bottom <=
      (window.innerHeight || document.documentElement.clientHeight) &&
    rect.right <= (window.innerWidth || document.documentElement.clientWidth)
  );
}

class VariantPair extends HTMLElement {
  constructor() {
    super();

    this.addEventListener("change", this.onVariantChange);
  }

  onVariantChange() {
    const pairAddtoCartWrap = document.querySelector("pair-add-to-cart");
    if (!pairAddtoCartWrap) {
      console.warn("[VariantChange] pair-add-to-cart not found");
      return;
    }
  
    const pairAddtoCart = pairAddtoCartWrap.querySelector(".product-form__submit");
    const pairTotalPrices = document.querySelectorAll(".pair-total-price");
    const pairTotalComparePrices = document.querySelectorAll(".pair-compare-total-price");
    const savingPercents = document.querySelectorAll(".savings-percent");
    const allQtyInputs = this.querySelectorAll('[name="quantity"]');
  
    let totalQty = 0;
    let totalPrice = 0;
    let totalComparePrice = 0;
    let allHaveCompare = true;
  
    allQtyInputs.forEach((input) => {
      const qty = parseInt(input.value) || 0;
      const price = parseInt(input.getAttribute("data-price")) || 0;
      const comparePrice = parseInt(input.getAttribute("data-compare-price")) || 0;
  
      totalQty += qty;
      totalPrice += price * qty;
  
      if (comparePrice > 0) {
        totalComparePrice += comparePrice * qty;
      } else {
        allHaveCompare = false;
      }
    });
  
    // Enable/disable Add to Cart button
    if (pairAddtoCart) {
      pairAddtoCart.toggleAttribute("disabled", totalQty === 0);
    }
  
    // Update total price
    pairTotalPrices.forEach((el) => {
      el.innerText = formatMoney(totalPrice, window.shopSettings.moneyFormat);
    });
  
    // Update compare price and savings if all have compare prices
    if (allHaveCompare && totalComparePrice > totalPrice) {
      const savings = (((totalComparePrice - totalPrice) * 100) / totalComparePrice).toFixed(0);
  
      pairTotalComparePrices.forEach((el) => {
        el.innerText = formatMoney(totalComparePrice, window.shopSettings.moneyFormat);
      });
  
      savingPercents.forEach((el) => {
        el.innerText = `Save ${savings}%`;
      });
    } else {
      // If not all have compare price, hide compare prices and savings
      pairTotalComparePrices.forEach((el) => el.innerText = "");
      savingPercents.forEach((el) => el.innerText = "");
    }
  
    console.log(
      `[VariantChange] totalQty: ${totalQty}, totalPrice: ${totalPrice}, totalCompare: ${totalComparePrice}, allHaveCompare: ${allHaveCompare}`
    );
  }
}

customElements.define("variant-pair", VariantPair);

class PairAddToCart extends HTMLElement {
  constructor() {
    super();

    this.submitButton = this.querySelector(".product-form__submit");
    this.submitButton.addEventListener(
      "click",
      this.onSubmitHandler.bind(this)
    );
    this.inputs = document.querySelectorAll(".js-pair-qty-input");
    this.cart =
      document.querySelector("cart-notification") ||
      document.querySelector("cart-drawer");

    document.addEventListener("scroll", this.handleCTAbutton.bind(this), {
      passive: true,
    });
  }

  onSubmitHandler(evt) {
  evt.preventDefault();
  if (this.submitButton.getAttribute("aria-disabled") === "true") return;

  this.submitButton.setAttribute("aria-disabled", true);
  this.submitButton.classList.add("loading");

  let items = [];

  this.inputs.forEach((el) => {
    if (el.value > 0) {
      items.push({
        id: el.dataset.id,
        quantity: parseInt(el.value),
        bufferUK: el.dataset.bufferUk ? parseInt(el.dataset.bufferUk) : null
      });
    }
  });

  if (items.length === 0) return;

  fetch("/cart.js")
    .then((r) => r.json())
    .then((cartData) => {
      let validationFailed = false;
      let errorMessage = "";

      items.forEach((item) => {
        const existing = cartData.items.find((i) => i.variant_id == item.id);
        const alreadyInCartQty = existing ? existing.quantity : 0;

        if (item.bufferUK && alreadyInCartQty + item.quantity > item.bufferUK) {
          validationFailed = true;
          errorMessage = `Only ${item.bufferUK} units available for UK customers.`;
        }
      });

      if (validationFailed) {
        this.submitButton.classList.remove("loading");
        this.submitButton.removeAttribute("aria-disabled");

        const errors =
          document.getElementById("CartDrawer-CartErrors") ||
          document.getElementById("cart-errors") ||
          document.getElementById("product-errors");

        if (errors) errors.textContent = errorMessage;

        const cartDrawer = document.querySelector('cart-drawer');

        if (cartDrawer && typeof cartDrawer.open === "function") {
          cartDrawer.open();
        } else {
          document.body.classList.add("overflow-hidden");
          document.querySelector('cart-drawer').classList.add("active");
        }

        return;
      }


      const data = {
        items: items.map((i) => ({ id: i.id, quantity: i.quantity })),
        sections: ["cart-drawer", "cart-icon-bubble"],
      };

      return fetch("/cart/add.js", {
        method: "POST",
        credentials: "same-origin",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify(data),
      })
        .then((response) => response.json())
        .then((response) => {
          this.submitButton.classList.remove("loading");
          this.submitButton.removeAttribute("aria-disabled");

          $.ajax({
            type: "GET",
            url: "/cart.js",
            dataType: "json",
            success: function (data) {
              if (data) {
                var obj = data.items;
                var gtot = 0;
                $.each(obj, function (key, value) {
                  gtot = value.grams * value.quantity + gtot;
                });
                var weight = Math.round(gtot / 453.6);
                var maxWeight = 600;
                var percentage = Math.min(Math.round((weight / maxWeight) * 100), 100);
                var pt = percentage + "%";

                
              }

              if ($("#shipping-estimates .totals-est").length > 0) {
                $.ajax({
                  type: "POST",
                  url: "//hook.us1.make.celonis.com/b10fd8ltisl5fzxo7728u6tst301how6",
                  data: data,
                  dataType: "json",
                  success: function (data) {
                    const { total_price, original_price } = data.rates[0];
                    $("#shipping-estimates .totals-est").text("$" + parseInt(total_price) / 100);
                    $("#shipping-estimates2 .totals-est").text("$" + parseInt(total_price) / 100);
                    $("#shipping-estimates .totals-esttot").text(original_price);
                    $("#shipping-estimates2 .totals-esttot").text(original_price);
                  },
                });
              }
            },
          });

          if (this.cart) {
            if (this.cart.classList.contains("is-empty"))
              this.cart.classList.remove("is-empty");
            this.cart.renderContents(response);
            setTimeout(() => {
              shipping_est();
            }, 50);
          }
        })
        .catch((error) => console.error("Error:", error));
    });
}


  handleCTAbutton() {
    const cartAvailable = isInViewport(this.submitButton);
    const floatingCTA = document.querySelector(".js-pdp-floating-cta");
    const addToCart = this.querySelector(".product-form__submit");
    const floatingCTAHTML = `<div class="product-form-floating-cta js-pdp-floating-cta">
      <button id="selectWeightBtn" class="select-weight-button floating-add-to-cart-btn button button--full-width button--secondary"> 
        Select Weight
        <svg aria-hidden="true" focusable="false" role="presentation" class="icon icon-caret" viewBox="0 0 10 6" style="width: 1.8rem; margin-left: 0.5rem;">
          <path fill-rule="evenodd" clip-rule="evenodd" d="M9.354.646a.5.5 0 00-.708 0L5 4.293 1.354.646a.5.5 0 00-.708.708l4 4a.5.5 0 00.708 0l4-4a.5.5 0 000-.708z" fill="currentColor">
          </path>
        </svg>
      </button>
    </div>`;

    if (window.innerWidth < 768) {
      if (cartAvailable) {
        if (floatingCTA) {
          floatingCTA.remove();
        }
      } else {
        if (floatingCTA) {
          floatingCTA.addEventListener("click", function () {
            addToCart.click();
            if (addToCart.hasAttribute("disabled")) {
              document
                .querySelector(".sidebar__inner")
                .scrollIntoView({ behavior: "smooth" });
            }
          });
        } else {
          this.insertAdjacentHTML("beforeend", floatingCTAHTML);
        }
      }
    }
  }
}

customElements.define("pair-add-to-cart", PairAddToCart);
const footerr = document.querySelector("footer");
const footer_observer = new IntersectionObserver((entries) => {
  entries.forEach((entry) => {
    if (entry.isIntersecting) {
      if (document.querySelector(".floating-add-to-cart-btn"))
        document.querySelector(".floating-add-to-cart-btn").style.display =
          "none";
    } else {
      if (document.querySelector(".floating-add-to-cart-btn"))
        document.querySelector(".floating-add-to-cart-btn").style.display =
          "block";
    }
  });
});
footer_observer.observe(footerr);
